import { ServiceApi } from '../../utils/auth'

const state = {
    users: [],
    pendingTranfers: [],
    myConvertions: [],
    coupons: [],
    loading: false,
    error: null,
}

const actions = {
    // LIST COMPANY
    async fetchUsers({ commit }, payload) {
        commit('usersBegin')
        try {
            const res = await ServiceApi.get(`/api/get-users`, payload);
            commit("SET_USERS", res.data);
            commit('usersSuccess', true)
            return res.data;
        } catch (error) {
            commit('usersErr', error)
            return error
        }
    },
    async addWgpToUser({ commit }, payload) {
        commit('usersBegin')
        try {
            const res = await ServiceApi.post(`/api/add-points-to-a-user`, payload);
            commit('usersSuccess', true)
            return res.data;
        } catch (error) {
            commit('usersErr', error)
            return error
        }
    },
    async findUserByEmail({ commit }, payload) {
        commit('usersBegin')
        try {
            const res = await ServiceApi.get(`api/find_user_by_email`, payload);
            commit('usersSuccess', true)
            return res.data;
        } catch (error) {
            commit('usersErr', error)
            return error
        }
    },

    async asignUserCompany({ commit }, payload) {
        commit('usersBegin')
        try {
            const resp = await ServiceApi.post("api/add_user_to_company", payload);
            commit('usersSuccess', true)
            return resp.data;
        } catch (error) {
            commit('usersErr', error)
            return error
        }
    },
    async getUsersRewards({ commit }, value) {
        commit('usersBegin')
        try {
            if (value) {
                const url = value.search
                    ? `/api/user-rewards?paginated=true&page=${value.currentPage}&per_page=${value.perPage}&search=${value.search}`
                    : `/api/user-rewards?paginated=true&page=${value.currentPage}&per_page=${value.perPage}`;
                const res = await ServiceApi.get(url);
                commit("SET_USERS", res.data);
                commit('usersSuccess', true)
                return res.data;
            }
        } catch (error) {
            commit('usersErr', error)
            return error
        }
    },
    async transfersPending({ commit }, payload) {
        commit('usersBegin')
        try {
            const res = await ServiceApi.get('/api/transfer-requests', payload);
            commit("SET_TRANSFERS_PENDING", res.data);
            commit('usersSuccess', true)
            return res.data;
        } catch (error) {
            commit('usersErr', error)
            return error
        }
    },
    async actionsTransfers({ commit }, payload) {
        commit('usersBegin')
        try {
            const res = await ServiceApi.post(`/api/change-transfer-request-status/${payload.id}`, payload);
            commit('usersSuccess', true)
            return res.data;
        } catch (error) {
            commit('usersErr', error)
            return error
        }
    },
    async myConvertions({ commit }, payload) {
        commit('usersBegin')
        try {
            const res = await ServiceApi.get('/api/my-conversions', payload);
            commit("SET_MY_CONVERTION", res.data);
            commit('usersSuccess', true)
            return res.data;
        } catch (error) {
            commit('usersErr', error)
            return error
        }
    },
    async myCoupons({ commit, getters }, payload) {
        commit('usersBegin')
        try {
            const res = await ServiceApi.get(`/api/advertising/verified-coupons/${getters.user.id}`, payload);
            commit("SET_MY_COUPONS", res.data);
            commit('usersSuccess', true)
            return res.data;
        } catch (error) {
            commit('usersErr', error)
            return error
        }
    },
}

const getters = {
    getUsers: state => state.users,
    getTranfersPending: state => state.pendingTranfers,
    getMyConvertions: state => state.myConvertions,
    getCoupons: state => state.coupons,
    usersLoading: (state) => state.loading,
}

const mutations = {
    SET_USERS(state, payload) {
        state.users = payload.data
    },
    SET_TRANSFERS_PENDING(state, payload) {
        state.pendingTranfers = payload.data
    },
    SET_MY_CONVERTION(state, payload) {
        state.myConvertions = payload.data
    },
    SET_MY_COUPONS(state, payload) {
        state.coupons = payload.data
    },
    usersBegin(state) {
        state.loading = true
    },
    usersSuccess(state) {
        state.loading = false
    },
    usersErr(state, err) {
        state.loading = false
        state.error = err
    },
}

export default {
    namespaced: false,
    state,
    actions,
    mutations,
    getters
}
